﻿//function adjustModalMaxHeightAndPosition() {
//    $('.modal').each(function () {
//        if ($(this).hasClass('in') === false) {
//            $(this).show();
//        }
//        var contentHeight = $(window).height() - 60;
//        var headerHeight = $(this).find('.modal-header').outerHeight() || 2;
//        var footerHeight = $(this).find('.modal-footer').outerHeight() || 2;

//        $(this).find('.modal-content').css({
//            'max-height': function () {
//                return contentHeight;
//            }
//        });

//        $(this).find('.modal-body').css({
//            'max-height': function () {
//                return contentHeight - (headerHeight + footerHeight);
//            }
//        });

//        $(this).find('.modal-dialog').addClass('modal-dialog-center').css({
//            'margin-top': function () {
//                return -($(this).outerHeight() / 2);
//            },
//            'margin-left': function () {
//                return -($(this).outerWidth() / 2);
//            }
//        });
//        if ($(this).hasClass('in') === false) {
//            $(this).hide();
//        }
//    });
//}
//if ($(window).height() >= 320) {
//    $(window).resize(adjustModalMaxHeightAndPosition).trigger("resize");
//}

function fnValidarEnter(e) {
    if (e.keyCode == 13) {
        var usuario = false;
        var senha = false;

        if ($("#txtUsuario").val() == "master") {
            usuario = true;
        }

        if ($("#txtSenha").val() == "1234") {
            senha = true;
        }

        if (usuario && senha) {
            window.location.href = "master.html";
        } else if (!usuario && !senha) {
            sbExibirNotificacao("Usuário e Senha Inválidos!", "Atenção!", "danger");
        } else {
            if (!usuario) {
                sbExibirNotificacao("Usuário Inválido!", "Atenção!", "danger");
            } else {
                sbExibirNotificacao("Senha Inválida!", "Atenção!", "danger");
            }
        }
    }
}

function fnValidar() {
    var usuario = false;
    var senha = false;

    if ($("#txtUsuario").val() == "master") {
        usuario = true;
    }

    if ($("#txtSenha").val() == "1234") {
        senha = true;
    }

    if (usuario && senha) {
        window.location.href = "master.html";
    } else if (!usuario && !senha) {
        sbExibirNotificacao("Usuário e Senha Inválidos!", "Atenção!", "danger");
    } else {
        if (!usuario) {
            sbExibirNotificacao("Usuário Inválido!", "Atenção!", "danger");
        } else {
            sbExibirNotificacao("Senha Inválida!", "Atenção!", "danger");
        }
    }
}

function sbExibirNotificacao(msg, Titulo, tipo) {

    var icon = "";

    switch (tipo) {
        case "success":
            icon = "fa fa-2x fa-check mr-xs";
            break;
        case "danger":
            icon = "fa fa-2x fa-times mr-xs";
            break;
        case "info":
            icon = "fa fa-2x fa-info mr-xs";
            break;
        case "warning":
            icon = "fa fa-2x fa fa-exclamation-triangle mr-xs";
            break;
    }

    $.growl({
        title: '<strong>' + Titulo + '</strong>',
        message: '<br />' + msg,
        icon: icon,
    }, {
        z_index: 1041,
        mouse_over: 'pause',
        placement: {
            align: 'center'
        },
        delay: 5000,
        type: tipo
    });

}

$('.dinheiro').mask('#.##0,00', { reverse: true });
$('.numeros').mask('00000000000000000', { reverse: true });
$('.data').mask("00/00/0000", { placeholder: "__/__/____" });
var cpfCnpj = function(val) {
        return val.length > 14 ? '00.000.000/0000-00' : '000.000.000-009';
    },
    optionsDocumento = {
        onKeyPress: function(val, e, field, options) {
            field.mask(cpfCnpj(val), options);
        }
    };

$('.cpf-cnpj').mask(cpfCnpj, optionsDocumento);
$('.cpf').mask('000.000.000-00');
$('.cnpj').mask('00.000.000/0000-00');
$('.processo').mask('0000000-00.0000.0.00.0000', { placeholder: "______-__.____._.__.____" });

/* Datepicker modificações */
// Evento pageLoad para executa JS quando existir um Partial Postback
$(document).ready(function() {
    $('.dropdown-menu').click(function(event) {
        event.stopPropagation();
    });

    /* Mascaras */
    $('.dinheiro').mask('#.##0,00', { reverse: true });
    $('.numeros').mask('00000000000000000', { reverse: true });
    $('.data').mask("00/00/0000", { placeholder: "__/__/____" });
    $('.celular').mask("(00) 00000-0000", { placeholder: "()" });
    var cpfCnpj = function(val) {
            return val.length > 14 ? '00.000.000/0000-00' : '000.000.000-009';
        },
        optionsDocumento = {
            onKeyPress: function(val, e, field, options) {
                field.mask(cpfCnpj(val), options);
            }
        };

    $('.cpf-cnpj').mask(cpfCnpj, optionsDocumento);
    $('.cpf').mask('000.000.000-00');
    $('.cnpj').mask('00.000.000/0000-00');
    $('.processo').mask('0000000-00.0000.0.00.0000', { placeholder: "______-__.____._.__.____" });
    $('.mes-ano').mask('00/0000', { placeholder: "__/____" });
    $('.datepicker').datepicker({
        format: "dd/mm/yyyy",
        todayHighlight: true,
        todayBtn: "linked",
        autoclose: true
    });

    $('.datepicker-mm-yyyy').datepicker({
        format: "mm/yyyy",
        autoclose: true,
        minViewMode: 1,
        startDate: "01/2015"
    });
});